import React from 'react';
import PropTypes from 'prop-types';
import { CANCELLATION_LATE } from 'constants/cancellation-types';
import { CancellationPolicyEarly } from './CancellationPolicyEarly';
import { CancellationPolicyLate } from './CancellationPolicyLate';
export var CancellationPolicy = function CancellationPolicy(_ref) {
  var isTopUp = _ref.isTopUp,
      endOfCycleDate = _ref.endOfCycleDate,
      msaTimeZone = _ref.msaTimeZone,
      lateCancellation = _ref.lateCancellation,
      cancellationPolicy = _ref.cancellationPolicy,
      onLateCancellationConfirmation = _ref.onLateCancellationConfirmation,
      children = _ref.children;
  return lateCancellation === CANCELLATION_LATE ? React.createElement(CancellationPolicyLate, {
    isTopUp: isTopUp,
    cancellationPolicy: cancellationPolicy,
    endOfCycleDate: endOfCycleDate,
    msaTimeZone: msaTimeZone,
    onLateCancellationConfirmation: onLateCancellationConfirmation
  }, children) : React.createElement(CancellationPolicyEarly, {
    isTopUp: isTopUp,
    cancellationPolicy: cancellationPolicy,
    endOfCycleDate: endOfCycleDate,
    msaTimeZone: msaTimeZone
  }, children);
};
CancellationPolicy.propTypes = {
  isTopUp: PropTypes.bool,
  endOfCycleDate: PropTypes.number.isRequired,
  msaTimeZone: PropTypes.string.isRequired,
  lateCancellation: PropTypes.string.isRequired,
  cancellationPolicy: PropTypes.string.isRequired,
  onLateCancellationConfirmation: PropTypes.func.isRequired,
  children: PropTypes.node
};